import * as HttpService from './HttpService'

let namespace = 'settings'

let cleanup = (params, cb, errorCb) => {
    HttpService.get(namespace + '/cleanup', params, cb, errorCb)
}

let update = (body, cb, errorCb) => {
    HttpService.post('company/settings', body, cb, errorCb)
}

export {
    cleanup,
    update
}



// WEBPACK FOOTER //
// ./src/services/settingsService.js